export default (function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.pa.config.FlowConfig.Error creating claim',
                message: 'fnol.pa.config.FlowConfig.An error occurred attempting to create personal auto claim.'
            },
            progress: {
                message: 'fnol.pa.config.FlowConfig.Creating personal auto draft claim...'
            }
        },
        saveDraftClaim: {
            error: {
                title: 'fnol.common.config.FlowConfig.Unable to save draft claim information',
                message: 'fnol.common.config.FlowConfig.An error occurred while attempting to save the claim submission.'
            },
            progress: {
                message: 'fnol.common.config.FlowConfig.Saving draft claim details...'
            }
        },
        submitClaim: {
            error: {
                title: 'fnol.common.config.FlowConfig.Error submitting claim',
                message: 'fnol.common.config.FlowConfig.An error occurred attempting to submit the claim.'
            },
            progress: {
                message: 'fnol.common.config.FlowConfig.Submitting claim details...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(model) {
            if (model.claimNumber.value) {
                return $q.resolve(model);
            }
            return LoadSaveService.createClaim(model.value);
        },
        saveDraftClaim: function saveDraftClaim(model) {
            return LoadSaveService.saveClaim(model.value);
        },
        submitClaim: function submitClaim(model) {
            return LoadSaveService.submitClaim(model.value);
        }
    };

    return function (step, junction) {
        junction('puwError');
        junction('puwSuccess');

        junction('puwInit', true).onNext.doAction(ACTIONS.createClaim, ACTION_MSG.createClaim, { forceUpdate: true }).thenGoTo('puwClaimDetails', 'puwError');

        step('puwClaimDetails').onNext.doAction(ACTIONS.saveDraftClaim, ACTION_MSG.saveDraftClaim, { forceUpdate: true }).thenGoTo('puwMoreInfo', 'puwError').label(function () {
            return translateFn('fnol.wizard.steps.puw.ClaimDetails');
        });

        step('puwMoreInfo').onNext.doAction(ACTIONS.saveDraftClaim, ACTION_MSG.saveDraftClaim, { forceUpdate: true }).thenGoTo('puwMainContact', 'puwError').label(function () {
            return translateFn('fnol.wizard.step.Additional Information');
        });

        step('puwMainContact').onNext.doAction(ACTIONS.saveDraftClaim, ACTION_MSG.saveDraftClaim, { forceUpdate: true }).thenGoTo('puwFnolSummary', 'puwError').label(function () {
            return translateFn('fnol.wizard.step.Contact Details');
        });

        step('puwFnolSummary').onNext.doAction(ACTIONS.submitClaim, ACTION_MSG.submitClaim, { forceUpdate: true }).thenGoTo('puwSuccess', 'puwError').label(function () {
            return translateFn('fnol.wizard.step.Summary');
        });
    };
});